import { Icon, Tooltip } from '@mairistem/composants';
import { Feature, Menu } from '@mairistem/module';
import _ from 'lodash';

import { MENUS } from '@/constants';
import { showTooltips } from '@/utils';
import { useRegieStore, useRegisseurStore } from '@/zustand';
import Parametrage from './Parametrage';

// Icône stable (hors rendu) : @mairistem/module ré-enregistre le menu, en fin de liste, dès que
// l'icône change de référence — ce qui arriverait à chaque re-rendu dû aux stores.
const ICON = showTooltips ? (
  <Tooltip trigger={<Icon name="settings" />} message="Paramètres" position="right center" />
) : (
  <Icon name="settings" />
);

const MenuParametrage = () => {
  const disabledMenus = useRegieStore((state) => state.disabledMenus);
  const regisseur = useRegisseurStore((state) => state.regisseur);

  return (
    <Menu
      code={MENUS.MENU_SETTINGS}
      name="Paramètres"
      icon={ICON}
      path="/parametres"
      // @ts-expect-error
      visible={!_.isNil(regisseur) && !disabledMenus?.parametrage}
    >
      <Feature>
        <Feature.Content>
          <Parametrage />
        </Feature.Content>
      </Feature>
    </Menu>
  );
};

export default MenuParametrage;
